// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { ComponentProps } from 'react';
import styled from 'styled-components';
import ReactMarkdown from 'react-markdown';
import ZoomIn from '../../assets/images/zoom-in.svg';

function NoTranslate(props: ComponentProps<'div'>) {
  return <div translate="no" {...props} />
}

export const S = {
  ReactMarkdown: styled(ReactMarkdown)<ReactMarkdown.ReactMarkdownProps>`
    /* Global Setting */
    * {
      font-size: 16px;
      line-height: 30px;
      color: #666666;
    }
    /* Disable select */
    * {
      user-select: none;
      -webkit-user-select: none;
      -ms-user-select: none;
      -moz-user-select: none;
      -webkit-touch-callout: none;
      -webkit-user-drag: auto;
    }
    /* margins */
    > * + * {
      margin-top: 30px;
    }

    li > :not(ol):not(ul) + :not(ol):not(ul) {
      /* margin-top: 30px; */
    }

    h1, h2, h3, h4, h5, h6 {
      & + * {
        margin-top: 12px;
      }
    }

    /* Header Styles */
    h1 {
      font-weight: bold;
      font-size: 32px;
      line-height: 46px;
      color: #666666;
    }

    h2 {
      font-weight: 500;
      font-size: 24px;
      line-height: 35px;
      color: #434343;
    }

    h3 {
      font-size: 20px;
      line-height: 29px;
      color: #434343;
    }

    em {
      color: #EF8200;
    }

    code {
      display: inline-block;
      padding: 2px 6px;
      margin: 0 2px;
      background-color: #f0f0f0;
      border-radius: 4px;
      line-height: 22px;

      &, * {
        font-family: Consolas, monaco, monospace !important;
        user-select: text;
        -webkit-user-select: text;
        -ms-user-select: text;
        -moz-user-select: text;
        -webkit-touch-callout: revert;
        -webkit-user-drag: auto;

        .linenumber {
          user-select: none;
          -webkit-user-select: none;
          -ms-user-select: none;
          -moz-user-select: none;
        }
      }
    }

    img {
      margin-top: 20px;
    }

    pre {
      margin-top: 12px;
      padding: 8px 12px;
      border-radius: 2px;
      background-color: #f0f0f0;
      white-space: normal;
    }

    a {
      color: #EF8200;
      text-decoration: underline;

      * {
        color: #EF8200;
        text-decoration: underline;
      }
    }

    strong {
      font-weight: bold;

      * {
        font-weight: bold;
      }
    }

    ul {
      margin-left: 20px;
    }

    ol {
      margin-left: 18px;

      li {
        padding-left: 2px;
      }
    }

    ul {
      list-style-type: revert;
    }

    ol {
      list-style-type: revert;
    }

    & > ol, & > ul {
      ol, ul {
        margin-left: 30px;
      }
    }

    li {
      > img:nth-child(n+2) {
        margin-top: 12px;
      }

      > img:nth-last-child(n+2) {
        margin-bottom: 12px;
      }
    }

    blockquote {
      padding: 4px 12px;
      background: rgba(255, 245, 6, 0.1);
      border-left: 8px solid #FFF506;
    }

    table {
      margin: 16px 0;
      color: #303030;
      border: 0;
      width: auto;
      display: block;
      overflow-x: auto;
      border-collapse: collapse;

      tr th {
        background-color: #f0f0f0;
        border-bottom: solid 2px #bfbfbf;
      }

      tr td, tr th {
        border: 1px solid #dbdbdb;
        padding: 10px 16px;
        line-height: 20px;
        vertical-align: middle;
      }

      tbody {
        background-color: #fff;
      }
    }
  `,
  Wrapper: styled(NoTranslate)`
  `,
  ExamWrapper: styled(NoTranslate)<{ checked?: boolean }>`
    ${(props) => (props.checked ? `
      p {
        color: #FFF;
      }
    ` : null)};
  `,
  WrapperLeft: styled.div`
    flex: 1;
    margin-right: 100px;
  `,
  LabInfoTitleSection: styled.div`
    padding: 0 30px;

    h1 {
      margin-bottom: 14.38px;
    }
  `,
  Img: styled.img`
    max-width: 70%;
    display: block;
  `,

  ImgZoomIn: styled.img.attrs({ src: ZoomIn })<{ isMulti: boolean }>`
    opacity: 0.4;
    cursor: pointer;
  `,

  ImgContainer: styled.span`
    display: flex;
    align-items: flex-end;
  `,
};
